function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_903_219)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.4999 16.8224C34.3256 16.8224 32.5645 15.0612 32.5645 12.8869V12.7196C32.5645 12.0014 32.7612 11.3028 33.1253 10.6928L35.6538 6.47204C36.008 5.88172 36.982 5.88172 37.3362 6.47204L39.8648 10.6928C40.2386 11.3028 40.4354 12.0112 40.4354 12.7196V12.8869C40.4354 15.0612 38.6743 16.8224 36.4999 16.8224ZM36.4999 8.89236L34.8175 11.7062C34.6306 12.0112 34.5322 12.3654 34.5322 12.7196V12.8869C34.5322 13.9691 35.4177 14.8546 36.4999 14.8546C37.5822 14.8546 38.4677 13.9691 38.4677 12.8869V12.7196C38.4677 12.3654 38.3693 12.0112 38.1824 11.7062L36.4999 8.89236Z",
  fill: "url(#paint0_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.871 38.4679C11.6967 38.4679 9.93555 36.7067 9.93555 34.5324V34.3651C9.93555 33.6469 10.1323 32.9484 10.4964 32.3384L13.0249 28.1175C13.3791 27.5272 14.3531 27.5272 14.7073 28.1175L17.2359 32.3384C17.6097 32.9484 17.8065 33.6567 17.8065 34.3651V34.5324C17.8065 36.7067 16.0454 38.4679 13.871 38.4679ZM13.871 30.5379L12.1886 33.3517C12.0017 33.6567 11.9033 34.0109 11.9033 34.3651V34.5324C11.9033 35.6146 12.7888 36.5001 13.871 36.5001C14.9533 36.5001 15.8388 35.6146 15.8388 34.5324V34.3651C15.8388 34.0109 15.7404 33.6567 15.5535 33.3517L13.871 30.5379Z",
  fill: "url(#paint1_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.1288 28.629C56.9545 28.629 55.1934 26.8679 55.1934 24.6935V24.5263C55.1934 23.808 55.3901 23.1095 55.7542 22.4995L58.2827 18.2787C58.6369 17.6884 59.6109 17.6884 59.9651 18.2787L62.4937 22.4995C62.8676 23.1095 63.0643 23.8179 63.0643 24.5263V24.6935C63.0643 26.8679 61.3032 28.629 59.1288 28.629ZM59.1288 20.699L57.4464 23.5129C57.2595 23.8179 57.1611 24.1721 57.1611 24.5263V24.6935C57.1611 25.7758 58.0466 26.6613 59.1288 26.6613C60.2111 26.6613 61.0966 25.7758 61.0966 24.6935V24.5263C61.0966 24.1721 60.9982 23.8179 60.8113 23.5129L59.1288 20.699Z",
  fill: "url(#paint2_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.0171 14.8545C66.5605 14.8545 67.0009 14.414 67.0009 13.8706C67.0009 13.3272 66.5605 12.8867 66.0171 12.8867C65.4737 12.8867 65.0332 13.3272 65.0332 13.8706C65.0332 14.414 65.4737 14.8545 66.0171 14.8545Z",
  fill: "url(#paint3_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2905 20.7578C49.8339 20.7578 50.2744 20.3173 50.2744 19.7739C50.2744 19.2305 49.8339 18.79 49.2905 18.79C48.7471 18.79 48.3066 19.2305 48.3066 19.7739C48.3066 20.3173 48.7471 20.7578 49.2905 20.7578Z",
  fill: "url(#paint4_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.2261 7.96774C53.7694 7.96774 54.2099 7.52725 54.2099 6.98387C54.2099 6.44049 53.7694 6 53.2261 6C52.6827 6 52.2422 6.44049 52.2422 6.98387C52.2422 7.52725 52.6827 7.96774 53.2261 7.96774Z",
  fill: "url(#paint5_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7417 33.5488C22.2851 33.5488 22.7256 33.1083 22.7256 32.5649C22.7256 32.0215 22.2851 31.5811 21.7417 31.5811C21.1983 31.5811 20.7578 32.0215 20.7578 32.5649C20.7578 33.1083 21.1983 33.5488 21.7417 33.5488Z",
  fill: "url(#paint6_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.4995 24.6933C37.0429 24.6933 37.4834 24.2528 37.4834 23.7095C37.4834 23.1661 37.0429 22.7256 36.4995 22.7256C35.9561 22.7256 35.5156 23.1661 35.5156 23.7095C35.5156 24.2528 35.9561 24.6933 36.4995 24.6933Z",
  fill: "url(#paint7_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6772 12.8867C26.2206 12.8867 26.6611 12.4462 26.6611 11.9028C26.6611 11.3594 26.2206 10.9189 25.6772 10.9189C25.1339 10.9189 24.6934 11.3594 24.6934 11.9028C24.6934 12.4462 25.1339 12.8867 25.6772 12.8867Z",
  fill: "url(#paint8_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.98387 7.96774C7.52725 7.96774 7.96774 7.52725 7.96774 6.98387C7.96774 6.44049 7.52725 6 6.98387 6C6.44049 6 6 6.44049 6 6.98387C6 7.52725 6.44049 7.96774 6.98387 7.96774Z",
  fill: "url(#paint9_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8706 19.7744C14.414 19.7744 14.8545 19.3339 14.8545 18.7905C14.8545 18.2471 14.414 17.8066 13.8706 17.8066C13.3272 17.8066 12.8867 18.2471 12.8867 18.7905C12.8867 19.3339 13.3272 19.7744 13.8706 19.7744Z",
  fill: "url(#paint10_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.0484 59.1289H61.0968C60.5556 59.1289 60.1129 58.6862 60.1129 58.1451C60.1129 57.6039 60.5556 57.1612 61.0968 57.1612H64.0484C64.5895 57.1612 65.0323 56.7185 65.0323 56.1773V44.8038C65.0323 44.6562 65.0027 44.5185 64.9437 44.3906L60.8016 35.4176C60.0047 33.686 58.2435 32.5644 56.3348 32.5644H33.8534C32.0135 32.5644 30.2819 33.2826 28.9832 34.5814L21.4468 42.1178C21.2697 42.2949 21.0237 42.4031 20.7581 42.4031H14.8548C11.0571 42.4031 7.96774 45.4925 7.96774 49.2902V56.1773C7.96774 56.7185 8.41048 57.1612 8.95161 57.1612H11.9032C12.4444 57.1612 12.8871 57.6039 12.8871 58.1451C12.8871 58.6862 12.4444 59.1289 11.9032 59.1289H8.95161C7.32823 59.1289 6 57.8007 6 56.1773V49.2902C6 44.4102 9.97484 40.4354 14.8548 40.4354H20.3547L27.596 33.1941C29.2685 31.5215 31.4921 30.5967 33.8534 30.5967H56.3348C59.011 30.5967 61.4706 32.1709 62.5923 34.601L66.7344 43.5739C66.9115 43.9576 67 44.3709 67 44.8038V56.1773C67 57.8007 65.6718 59.1289 64.0484 59.1289Z",
  fill: "url(#paint11_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9194 50.2743C10.3783 50.2743 9.93555 49.8316 9.93555 49.2904C9.93555 46.575 12.1394 44.3711 14.8549 44.3711C15.396 44.3711 15.8388 44.8138 15.8388 45.355C15.8388 45.8961 15.396 46.3388 14.8549 46.3388C13.2315 46.3388 11.9033 47.6671 11.9033 49.2904C11.9033 49.8316 11.4605 50.2743 10.9194 50.2743Z",
  fill: "url(#paint12_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.0175 48.3066H63.0659C62.5248 48.3066 62.082 47.8639 62.082 47.3227C62.082 46.7816 62.5248 46.3389 63.0659 46.3389H66.0175C66.5586 46.3389 67.0014 46.7816 67.0014 47.3227C67.0014 47.8639 66.5586 48.3066 66.0175 48.3066Z",
  fill: "url(#paint13_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.0175 52.2422H63.0659C62.5248 52.2422 62.082 51.7994 62.082 51.2583C62.082 50.7172 62.5248 50.2744 63.0659 50.2744H66.0175C66.5586 50.2744 67.0014 50.7172 67.0014 51.2583C67.0014 51.7994 66.5586 52.2422 66.0175 52.2422Z",
  fill: "url(#paint14_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.5014 47.3222H32.5659C32.0248 47.3222 31.582 46.8795 31.582 46.3384C31.582 45.7972 32.0248 45.3545 32.5659 45.3545H36.5014C37.0425 45.3545 37.4853 45.7972 37.4853 46.3384C37.4853 46.8795 37.0425 47.3222 36.5014 47.3222Z",
  fill: "url(#paint15_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.4194 59.1287C40.8783 59.1287 40.4355 58.6859 40.4355 58.1448V46.3384C40.4355 45.7972 40.8783 45.3545 41.4194 45.3545C41.9605 45.3545 42.4033 45.7972 42.4033 46.3384V58.1448C42.4033 58.6859 41.9605 59.1287 41.4194 59.1287Z",
  fill: "url(#paint16_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.3557 59.1289H27.646C27.1049 59.1289 26.6621 58.6861 26.6621 58.145C26.6621 57.6039 27.1049 57.1611 27.646 57.1611H45.3557C45.8968 57.1611 46.3395 57.6039 46.3395 58.145C46.3395 58.6861 45.8968 59.1289 45.3557 59.1289Z",
  fill: "url(#paint17_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7728 66.9997C14.8928 66.9997 10.918 63.0249 10.918 58.1449C10.918 53.2649 14.8928 49.29 19.7728 49.29C24.6528 49.29 28.6276 53.2649 28.6276 58.1449C28.6276 63.0249 24.6528 66.9997 19.7728 66.9997ZM19.7728 51.2578C15.9751 51.2578 12.8857 54.3471 12.8857 58.1449C12.8857 61.9426 15.9751 65.032 19.7728 65.032C23.5705 65.032 26.6599 61.9426 26.6599 58.1449C26.6599 54.3471 23.5705 51.2578 19.7728 51.2578Z",
  fill: "url(#paint18_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7734 62.0809C17.599 62.0809 15.8379 60.3198 15.8379 58.1454C15.8379 55.9711 17.599 54.21 19.7734 54.21C21.9477 54.21 23.7089 55.9711 23.7089 58.1454C23.7089 60.3198 21.9477 62.0809 19.7734 62.0809ZM19.7734 56.1777C18.6911 56.1777 17.8056 57.0632 17.8056 58.1454C17.8056 59.2277 18.6911 60.1132 19.7734 60.1132C20.8556 60.1132 21.7411 59.2277 21.7411 58.1454C21.7411 57.0632 20.8556 56.1777 19.7734 56.1777Z",
  fill: "url(#paint19_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.2259 66.9997C48.3459 66.9997 44.3711 63.0249 44.3711 58.1449C44.3711 53.2649 48.3459 49.29 53.2259 49.29C58.1059 49.29 62.0808 53.2649 62.0808 58.1449C62.0808 63.0249 58.1059 66.9997 53.2259 66.9997ZM53.2259 51.2578C49.4282 51.2578 46.3388 54.3471 46.3388 58.1449C46.3388 61.9426 49.4282 65.032 53.2259 65.032C57.0237 65.032 60.113 61.9426 60.113 58.1449C60.113 54.3471 57.0237 51.2578 53.2259 51.2578Z",
  fill: "url(#paint20_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.2245 62.0809C51.0502 62.0809 49.2891 60.3198 49.2891 58.1454C49.2891 55.9711 51.0502 54.21 53.2245 54.21C55.3989 54.21 57.16 55.9711 57.16 58.1454C57.16 60.3198 55.3989 62.0809 53.2245 62.0809ZM53.2245 56.1777C52.1423 56.1777 51.2568 57.0632 51.2568 58.1454C51.2568 59.2277 52.1423 60.1132 53.2245 60.1132C54.3068 60.1132 55.1923 59.2277 55.1923 58.1454C55.1923 57.0632 54.3068 56.1777 53.2245 56.1777Z",
  fill: "url(#paint21_linear_903_219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.7729 43.3871H25.3437C24.9502 43.3871 24.5862 43.1509 24.4386 42.7771C24.2812 42.413 24.3697 41.99 24.655 41.7046L30.391 35.9687C31.2962 35.0537 32.5654 34.5322 33.8542 34.5322H48.3073C48.8484 34.5322 49.2912 34.975 49.2912 35.5161C49.2912 36.0572 48.8484 36.5 48.3073 36.5H33.8542C33.077 36.5 32.3194 36.8148 31.7684 37.3658L27.7149 41.4193H59.2381L57.231 37.0706C57.0736 36.7263 56.7194 36.5 56.3357 36.5H52.2428C51.7016 36.5 51.2589 36.0572 51.2589 35.5161C51.2589 34.975 51.7016 34.5322 52.2428 34.5322H56.3357C57.4868 34.5322 58.5396 35.2013 59.0118 36.2442L61.6683 41.99C61.806 42.295 61.7863 42.6492 61.5994 42.9345C61.4223 43.2198 61.1075 43.3871 60.7729 43.3871Z",
  fill: "url(#paint22_linear_903_219)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_903_219",
  x1: 36.4999,
  y1: 6.0293,
  x2: 36.4999,
  y2: 16.8224,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_903_219",
  x1: 13.871,
  y1: 27.6748,
  x2: 13.871,
  y2: 38.4679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_903_219",
  x1: 59.1288,
  y1: 17.8359,
  x2: 59.1288,
  y2: 28.629,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_903_219",
  x1: 66.0171,
  y1: 12.8867,
  x2: 66.0171,
  y2: 14.8545,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_903_219",
  x1: 49.2905,
  y1: 18.79,
  x2: 49.2905,
  y2: 20.7578,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_903_219",
  x1: 53.2261,
  y1: 6,
  x2: 53.2261,
  y2: 7.96774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_903_219",
  x1: 21.7417,
  y1: 31.5811,
  x2: 21.7417,
  y2: 33.5488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_903_219",
  x1: 36.4995,
  y1: 22.7256,
  x2: 36.4995,
  y2: 24.6933,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_903_219",
  x1: 25.6772,
  y1: 10.9189,
  x2: 25.6772,
  y2: 12.8867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_903_219",
  x1: 6.98387,
  y1: 6,
  x2: 6.98387,
  y2: 7.96774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_903_219",
  x1: 13.8706,
  y1: 17.8066,
  x2: 13.8706,
  y2: 19.7744,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_903_219",
  x1: 36.5,
  y1: 30.5967,
  x2: 36.5,
  y2: 59.1289,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_903_219",
  x1: 12.8872,
  y1: 44.3711,
  x2: 12.8872,
  y2: 50.2743,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_903_219",
  x1: 64.5417,
  y1: 46.3389,
  x2: 64.5417,
  y2: 48.3066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_903_219",
  x1: 64.5417,
  y1: 50.2744,
  x2: 64.5417,
  y2: 52.2422,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_903_219",
  x1: 34.5336,
  y1: 45.3545,
  x2: 34.5336,
  y2: 47.3222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_903_219",
  x1: 41.4194,
  y1: 45.3545,
  x2: 41.4194,
  y2: 59.1287,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_903_219",
  x1: 36.5008,
  y1: 57.1611,
  x2: 36.5008,
  y2: 59.1289,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_903_219",
  x1: 19.7728,
  y1: 49.29,
  x2: 19.7728,
  y2: 66.9997,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_903_219",
  x1: 19.7734,
  y1: 54.21,
  x2: 19.7734,
  y2: 62.0809,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_903_219",
  x1: 53.2259,
  y1: 49.29,
  x2: 53.2259,
  y2: 66.9997,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_903_219",
  x1: 53.2245,
  y1: 54.21,
  x2: 53.2245,
  y2: 62.0809,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_903_219",
  x1: 43.0596,
  y1: 34.5322,
  x2: 43.0596,
  y2: 43.3871,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C90606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A0808"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_903_219"
}, /*#__PURE__*/React.createElement("rect", {
  width: 61,
  height: 61,
  fill: "white",
  transform: "translate(6 6)"
})));

function SvgCarwash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarwash);
export default __webpack_public_path__ + "static/media/carwash.641ae580.svg";
export { ForwardRef as ReactComponent };